import script from "./FloorPlan.vue?vue&type=script&setup=true&lang=js"
export * from "./FloorPlan.vue?vue&type=script&setup=true&lang=js"

import "./FloorPlan.vue?vue&type=style&index=0&id=6b80487c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b80487c"]])

export default __exports__